
import moment from "moment";
import { IDiemDanhConfigSelectRequest } from "../models/request/diem-danh/IDiemDanhConfigSelectRequest";
import { IDiemDanhLopBoMonChangeRequest } from "../models/request/diem-danh/IDiemDanhLopBoMonChangeRequest";
import { IDiemDanhLopBoMonPublishMarkRequest } from "../models/request/diem-danh/IDiemDanhLopBoMonPublishMarkRequest";
import { IDiemDanhLopBoMonSelectRequest } from "../models/request/diem-danh/IDiemDanhLopBoMonSelectRequest";
import { IDiemDanhLopChuNhiemChangeRequest } from "../models/request/diem-danh/IDiemDanhLopChuNhiemChangeRequest";
import { IDiemDanhLopChuNhiemPublishMarkRequest } from "../models/request/diem-danh/IDiemDanhLopChuNhiemPublishMarkRequest";
import { IDiemDanhLopChuNhiemReportRequest } from "../models/request/diem-danh/IDiemDanhLopChuNhiemReportRequest";
import { IDiemDanhLopChuNhiemSelectRequest } from "../models/request/diem-danh/IDiemDanhLopChuNhiemSelectRequest";
import { apiClient } from "./apiClient";
import { IDiemDanhSelectByTruongRequest } from "../models/request/diem-danh/IDiemDanhSelectByTruongRequest";
import { IDiemDanhSelectTongHopByTruongLopRequest, IDiemDanhSelectTongHopVangByTruongLopRequest } from "../models/request/diem-danh/IDiemDanhSelectTongHopByTruongLopRequest";
import { IDiemDanhTietHocHocSinhRequest, IDiemDanhTietHocReportRequest } from "../models/request/diem-danh/IDiemDanhTietHocReportRequest";
import { IDiemDanhNghiTheoTietHocSinhRequest, IDiemDanhNghiTheoTietRequest } from "../models/request/diem-danh/IDiemDanhNghiTheoTietRequest";

export const API_DIEMDANH_PATH = "diem-danh"
export const diemDanhApi = {
    SelectLopDiemDanhAsync: (request: IDiemDanhConfigSelectRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-lop-diem-danh`, request)
    },
    SelectByLopBoMonAsync: (request: IDiemDanhLopBoMonSelectRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-by-lopbomon`, request)
    },
    
    SelectBaseByLopBoMonAsync: (request: IDiemDanhLopBoMonSelectRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-base-by-lopbomon`, request)
    },
    DiemDanhLopBoMonAsync: (request: IDiemDanhLopBoMonChangeRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/diem-danh-lopbomon`, request)
    },
    SelectByLopChuNhiemAsync: (request: IDiemDanhLopChuNhiemSelectRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-by-lopchunhiem`, request)
    },
    SelectBaseByLopChuNhiemAsync: (request: IDiemDanhLopChuNhiemSelectRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/select-base-by-lopchunhiem`, request)
    },
    DiemDanhLopChuNhiemAsync: (request: IDiemDanhLopChuNhiemChangeRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/diem-danh-lopchunhiem`, request)
    },
    CheckOutHocsinhAsync: (request: IDiemDanhLopChuNhiemChangeRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/check-out-hocsinh`, request)
    },
    DiemDanhLopBoMonPublishMarkAsync: (request: IDiemDanhLopBoMonPublishMarkRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/diem-danh-lopbomon-publish-mark`, request)
    },
    DiemDanhLopChuNhiemPublishMarkAsync: (request: IDiemDanhLopChuNhiemPublishMarkRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/diem-danh-lopchunhiem-publish-mark`, request)
    },
    LopChuNhiemReportAsync: (request: IDiemDanhLopChuNhiemReportRequest) => {
        return apiClient.get(`${API_DIEMDANH_PATH}/lop-chu-nhiem/report/${moment(request.date).format("YYYY-MM-DD")}/co-so/${request.dm_truong_id}`)
    },
    SelectByTruongAsync: (request: IDiemDanhSelectByTruongRequest) => {
        return apiClient.get(`${API_DIEMDANH_PATH}/nam-hoc/${request.nam_hoc}/from-date/${moment(request.fromDate).format("YYYY-MM-DD")}/to-date/${moment(request.toDate).format("YYYY-MM-DD")}/truong/${request.dm_truong_id}`)
    },
    SelectTongHopByLopAsync: (request: IDiemDanhSelectTongHopByTruongLopRequest) => {
        return apiClient.get(`${API_DIEMDANH_PATH}/nam-hoc/${request.nam_hoc}/month/${moment(request.month).format("YYYY-MM")}/truong/${request.dm_truong_id}/khoi/${request.dm_khoi_id}/lop/${request.dm_lop_id}`)
    },
    SelectTongHopVangByLopAsync: (request: IDiemDanhSelectTongHopVangByTruongLopRequest) => {
        return apiClient.get(`${API_DIEMDANH_PATH}/tonghop-vang/lop/${request.dm_lop_id}`)
    },

    /* ------------------ Báo cáo điểm danh tiết học ------------------ */
    BaoCaoTietHocAsync: (request: IDiemDanhTietHocReportRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/bao-cao-tiet-hoc`, request)
    },
    BaoCaoTietHocHocSinhAsync: (request: IDiemDanhTietHocHocSinhRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/bao-cao-tiet-hoc/hoc-sinh`, request)
    },
    BaoCaoTietHocExportAsync: (request: IDiemDanhTietHocReportRequest) => {
        return apiClient.postBlob(`${API_DIEMDANH_PATH}/bao-cao-tiet-hoc/export`, request)
    },
    BaoCaoTietHocHocSinhExportAsync: (request: IDiemDanhTietHocHocSinhRequest) => {
        return apiClient.postBlob(`${API_DIEMDANH_PATH}/bao-cao-tiet-hoc/hoc-sinh/export`, request)
    },

    /* ------------------ Nghỉ theo tiết ------------------ */
    BaoCaoNghiTheoTietAsync: (request: IDiemDanhNghiTheoTietRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/bao-cao-nghi-theo-tiet`, request)
    },
    BaoCaoNghiTheoTietHocSinhAsync: (request: IDiemDanhNghiTheoTietHocSinhRequest) => {
        return apiClient.post(`${API_DIEMDANH_PATH}/bao-cao-nghi-theo-tiet/hoc-sinh`, request)
    },
    BaoCaoNghiTheoTietHocSinhExportAsync: (request: IDiemDanhNghiTheoTietHocSinhRequest) => {
        return apiClient.postBlob(`${API_DIEMDANH_PATH}/bao-cao-nghi-theo-tiet/hoc-sinh/export`, request)
    },
};